import Cookies from 'js-cookie'

const TokenKey = process.env.COOKIE_NAME

/**
 * 获取用户token
 */
export function getToken() {
  return Cookies.get('userToken')
}

/**
 * 存储用户token
 * @param {*} token 
 */
export function setToken(token) {
  return Cookies.set('userToken', token)
}

export function removeToken() {
  return Cookies.remove('userToken')
}


export function getCoookieForIssso() {
  try {
    var state = Cookies.get(TokenKey)
    state = JSON.parse(state)
    const { issso } = state
    return issso
  } catch (e) {
    console.log('_______auth:', e)
    return ''
  }
}

/**
 * 存入缓存
 * @param {*} name  key值
 * @param {*} value value值
 * @param {*} expires 缓存时间
 */
export function setCookies(name,value,expires = 7) {
  return Cookies.set(name, value, { expires: expires })
}

/**
 * 获取缓存
 * @param {*} name key值
 */
export function getCookies(name) {
  return Cookies.get(name)
}

/**
 * 删除缓存
 * @param {*} name key值
 */
export function removeCookies(name) {
  return Cookies.remove(name);
}


// WEBPACK FOOTER //
// ./src/utils/auth.js